import { useEffect, useState } from 'react';

import { useMutation } from '@redwoodjs/web';

import { showSuccessToast } from 'src/components/Toasts/toast';
import { REMIND_SEPA_DD } from 'src/graphql/mutations/sepaDD.mutation';
import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';
import { onError } from 'src/utils/utils';

import { SepaAgreementData, UseRemindSepaAgreementParams } from './type';

export default function useRemindSepaAgreement({
    merchantData,
    partnerData,
}: UseRemindSepaAgreementParams) {
    const [isRemindConfirmModalOpen, setIsRemindConfirmModalOpen] = useState<boolean>(false);
    const [idToRemind, setIdToRemind] = useState<{
        id: number;
        agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE;
    }>();
    const [remindData, setRemindData] = useState<SepaAgreementData | undefined>();

    const [remindSepaDD] = useMutation(REMIND_SEPA_DD, {
        onError,
        onCompleted: () => {
            showSuccessToast('Reminder sent successfully.');
        },
    });

    const handleRemindRecord = () => {
        if (idToRemind) {
            remindSepaDD({
                variables: {
                    id: idToRemind?.id,
                },
            });
        }
        setIsRemindConfirmModalOpen(false);
    };

    useEffect(() => {
        if (idToRemind) {
            const dataSource =
                idToRemind.agreementType === SEPA_MANDATE_AGREEMENT_TABLE_TYPE.MERCHANT
                    ? merchantData
                    : partnerData;

            const foundData = dataSource?.find((agreement) => {
                return Number(agreement.id) === idToRemind.id;
            });

            setRemindData(foundData);
        } else {
            setRemindData(undefined);
        }
    }, [idToRemind, merchantData, partnerData]);

    return {
        setIsRemindConfirmModalOpen,
        isRemindConfirmModalOpen,
        setIdToRemind,
        handleRemindRecord,
        remindData,
    };
}
